declare global {
  interface PromiseConstructor {
    try<T>(callback: () => T | PromiseLike<T>): Promise<T>;
    try<T, A extends unknown[]>(
      callback: (...args: A) => T | PromiseLike<T>,
      ...args: A
    ): Promise<T>;
  }
}

if (typeof Promise.try !== 'function') {
  Promise.try = function <T, A extends unknown[]>(
    callback: (...args: A) => T | PromiseLike<T>,
    ...args: A
  ): Promise<T> {
    return new Promise<T>((resolve) => {
      resolve(callback(...args));
    });
  };
}

export {};
